// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function ModalBody(Props) {
  var classNameOpt = Props.className;
  var children = Props.children;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "c-modal-body " + className
            }, children);
}

var make = ModalBody;

export {
  make ,
  
}
/* react Not a pure module */
